import TaxiCorporationPlanEntryBillingsDownloadRequest, {
  TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel,
  TaxiCorporationPlanEntryBillingsDownloadRequestOrder,
} from "../../../../api/raily/taxi-corporation/plan-entry-billings/download/taxi-corporation-plan-entry-billings-download.request";
import BillingModel from "../../../../types/billing-model";
import TaxiCorporationSortKey from "../../../../types/taxi-corporation-sort-key";
import TaxiCorporationPlanEntryBillingsDownloadParams from "./taxi-corporation-plan-entry-billings-download-params";

const createModel = (
  model: BillingModel | undefined,
): TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel | undefined => {
  switch (model) {
    case BillingModel.AB:
      return TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel.AB;
    case BillingModel.ABA:
      return TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel.ABA;
    case BillingModel.OTHER:
      return TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel.OTHER;
    case BillingModel.SABS:
      return TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel.SABS;
    default:
      return undefined;
  }
};

const createOrder = (
  sortKey: TaxiCorporationSortKey | undefined,
): TaxiCorporationPlanEntryBillingsDownloadRequestOrder | undefined => {
  switch (sortKey) {
    case TaxiCorporationSortKey.BILLING_MODEL_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.BILLING_MODEL_ASC;
    case TaxiCorporationSortKey.BILLING_MODEL_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.BILLING_MODEL_DESC;
    case TaxiCorporationSortKey.DISTANCE_AMOUNT_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_AMOUNT_ASC;
    case TaxiCorporationSortKey.DISTANCE_AMOUNT_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_AMOUNT_DESC;
    case TaxiCorporationSortKey.DISTANCE_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_ASC;
    case TaxiCorporationSortKey.DISTANCE_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_DESC;
    case TaxiCorporationSortKey.DISTANCE_RATE_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_RATE_ASC;
    case TaxiCorporationSortKey.DISTANCE_RATE_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DISTANCE_RATE_DESC;
    case TaxiCorporationSortKey.DRIVER_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DRIVER_ASC;
    case TaxiCorporationSortKey.DRIVER_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.DRIVER_DESC;
    case TaxiCorporationSortKey.HIGHWAY_CHARGE_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.HIGHWAY_CHARGE_ASC;
    case TaxiCorporationSortKey.HIGHWAY_CHARGE_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.HIGHWAY_CHARGE_DESC;
    case TaxiCorporationSortKey.HUMAN_ID_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.HUMAN_ID_ASC;
    case TaxiCorporationSortKey.HUMAN_ID_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.HUMAN_ID_DESC;
    case TaxiCorporationSortKey.TOTAL_AMOUNT_ASC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.TOTAL_AMOUNT_ASC;
    case TaxiCorporationSortKey.TOTAL_AMOUNT_DESC:
      return TaxiCorporationPlanEntryBillingsDownloadRequestOrder.TOTAL_AMOUNT_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: TaxiCorporationPlanEntryBillingsDownloadParams,
): TaxiCorporationPlanEntryBillingsDownloadRequest => {
  return {
    taxiCorporationUuid: params.taxiCorporationUuid,
    billingModel: createModel(params.billingModel),
    cargoOrderHumanId: params.cargoOrderHumanId,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    driver: params.driver,
    fleetPartner: params.fleetPartner,
    humanId: params.humanId,
    order: createOrder(params.sortKey),
  };
};

const taxiCorporationPlanEntryBillingsDownloadParamsFactory = {
  create,
};

export default taxiCorporationPlanEntryBillingsDownloadParamsFactory;
